'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "bulletin",
      class: {
        error: _vm.error,
        'show-close': _vm.showClose,
        'show-access': _vm.access,
        'text-cut': _vm.cut,
        'show-horn': _vm.horn
      },
      on: {
        "click": function click($event) {
          _vm.$emit('click');
        }
      }
    }, [_vm.showClose ? _c('i', {
      staticClass: "icon-error",
      on: {
        "click": _vm.handleClose
      }
    }) : _vm._e(), _vm._v(" "), _vm.access ? _c('i', {
      staticClass: "icon-access-big"
    }) : _vm._e(), _vm._v(" "), _vm.horn ? _c('i', {
      staticClass: "icon-horn"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "slide",
      staticClass: "bulletin-slide"
    }, [_c('div', {
      ref: "content",
      class: {
        center: _vm.textCenter,
        'in-motion': _vm.inMotion
      },
      style: {
        animationDuration: _vm.animationDuration
      },
      domProps: {
        "innerHTML": _vm._s(_vm.content)
      },
      on: {
        "animationend": _vm.onAnimationEnd
      }
    })])]);
  },
  staticRenderFns: [],
  name: 'bulletin',
  props: {
    text: {
      type: String,
      required: true
    },
    space: {
      type: Number,
      default: 20
    },
    speed: {
      type: Number,
      default: 20
    },
    delay: {
      type: Number,
      default: 800
    },
    error: {
      type: Boolean
    },
    close: {
      type: Boolean,
      default: false
    },
    access: {
      type: Boolean,
      default: false
    },
    cut: {
      type: Boolean,
      default: false
    },
    horn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      moving: false,
      // 是否滚动文字
      inMotion: false,
      // 动画中
      animationDuration: '0s',
      // 动画时长
      isLongText: false,
      // 文字长度是否超过容器
      showClose: this.close // 是否展示关闭按钮

    };
  },
  computed: {
    content: function content() {
      var text = this.text;

      if (this.moving) {
        for (var i = 0; i < this.space; i++) {
          text += '&nbsp';
        }

        return text + text;
      } else {
        return text;
      }
    },
    textCenter: function textCenter() {
      return !this.isLongText && !this.showClose && !this.access && !this.horn;
    }
  },
  mounted: function mounted() {
    if (this.text && this.speed > 0) {
      var slideWidth = this.$refs.slide.offsetWidth;
      var contentWidth = this.$refs.content.offsetWidth;

      if (contentWidth > slideWidth) {
        this.isLongText = true;

        if (!this.cut) {
          this.start();
          this.moving = true;
        }
      }
    } // 关闭按钮和链接同时存在，优先展示链接（右键头）


    if (this.access && this.showClose) {
      this.showClose = false;
    }
  },
  methods: {
    start: function start() {
      var slideWidth = this.$refs.slide.offsetWidth;
      this.animationDuration = "".concat(slideWidth / this.speed, "s");
      this.animation();
    },
    animation: function animation() {
      var _this = this;

      this.inMotion = false;
      window.setTimeout(function () {
        _this.inMotion = true;
      }, this.delay);
    },
    onAnimationEnd: function onAnimationEnd() {
      this.animation();
    },
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
});

exports.default = index;
